import { render } from "./ExcelIcon.vue?vue&type=template&id=f77e027e"
import script from "./ExcelIcon.vue?vue&type=script&lang=js"
export * from "./ExcelIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/ExcelIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f77e027e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f77e027e', __exports__)) {
    api.reload('f77e027e', __exports__)
  }
  
  module.hot.accept("./ExcelIcon.vue?vue&type=template&id=f77e027e", () => {
    api.rerender('f77e027e', render)
  })

}


export default __exports__